import { Accordion, Container, LoadingOverlay, ScrollArea, Text } from '@mantine/core';
import { FC, useState } from 'react';
import { customLoader } from '../../components/CustomLoader';
import NoDataFound from '../../components/NoDataFound';
import { useGetFaqs } from '../../services';
import FaqAccordionItem from './FaqAccordionItem';
import { useFaqScrollAreaStyles } from './styles';

const Faq: FC = () => {
  // const { data: faqData, isLoading, isSuccess } = useFAQService();
  const { data: faqData, isLoading, isSuccess } = useGetFaqs();

  const { classes: faqScrollAreaClasses } = useFaqScrollAreaStyles();

  const [currentlySelectedAccordion, setCurrentlySelectedAccordion] = useState<string | null>(null);

  return (
    <>
      <LoadingOverlay pos='fixed' loader={customLoader} visible={isLoading} />
      <Container mt='-18px'>
        <Text fz={16} fw={500} mt={24}>
          FAQ
        </Text>
        <ScrollArea.Autosize classNames={faqScrollAreaClasses} type='never' scrollbarSize={2}>
          {isSuccess && Array.isArray(faqData) ? (
            <>
              {faqData.length === 0 ? (
                <NoDataFound text='No data found.' />
              ) : (
                <>
                  <Accordion
                    value={currentlySelectedAccordion}
                    onChange={setCurrentlySelectedAccordion}
                    chevron={null}
                    styles={(theme) => ({
                      chevron: {
                        minWidth: 0,
                        width: 0,
                        margin: 0,
                      },
                    })}>
                    {faqData.map((faq, index) => (
                      <FaqAccordionItem
                        faq={faq}
                        index={index}
                        currentlySelectedAccordion={currentlySelectedAccordion}
                        key={index}
                      />
                    ))}
                  </Accordion>
                </>
              )}
            </>
          ) : null}
        </ScrollArea.Autosize>
      </Container>
    </>
  );
};

export default Faq;
